
import SortPicker from '../components/sort-picker.vue';
import Schedule from '../schedule/schedule.vue'
import FilledForm from '../form/filled-form.vue';
import Form2 from '../form/form2.vue';
import Report2 from '../report/report2.vue';

export default {
    name: 'v2',
    components: {
        SortPicker,
        Schedule,
        FilledForm,
        Form2,
        Report2
    },
    created() {

        let t = this;

        if (localStorage['cleaner_table_mode']) {
            t.mode = localStorage['cleaner_table_mode'];
        }

        if (localStorage['cleaner_table_scale']) {
            t.tableScale = Number(localStorage['cleaner_table_scale']);
        }

        t.statusDict = listToDict(t.list.status);

        t.month = (new Date()).getMonth() + 1;

        let d = new Date();
        d.setDate(d.getDate() - 2);

        t.startDate = new Date(d.format("yyyy/MM/dd"));
        t.endDate = new Date(t.startDate.getFullYear(), t.startDate.getMonth(), t.startDate.getDate() + 31);

        axios.get('employee?role=2').then(res => {
            if (res.data.status == 1) {
                t.list.cleaner = res.data.options.items;
                t.cleanerDict = {};

                t.list.cleaner.forEach(cleaner => {
                    t.cleanerDict[cleaner.id] = cleaner;
                });

                t.loadData();
            }
        });

        t.days = 31;

        let todayText = t.today.format('MM/dd');

        for (let i = 1; i <= t.days; i++) {
            let d = new Date(t.startDate.format('yyyy/MM/dd'));

            d.setDate(d.getDate() + i - 1);

            let date = d.format('MM/dd');

            t.monthGrid[date] = {
                k: 0,
                s: 0,
                suffix: ['日', '月', '火', '水', '木', '金', '土'][d.getDay()],
                is_today: date == todayText
            };
        }

        setInterval(() => {
            axios.get('cleanTask/waitingStats').then(res => {
                if (res.data.status == 1) {
                    let ids = res.data.options.ids;
                    let changed = false;
                    ids.forEach(item => {
                        if (t.dict.waitingTask[item] != 1) {
                            t.dict.waitingTask[item] = 1;
                            changed = true;
                        }
                    });
                    if (changed)
                        t.$forceUpdate();
                }
            });

        }, 3000);

    },
    activated() {

        let t = this;

    },
    methods: {

        reportFinish() {
            let t = this;

            if (t.gridItem.checkOutItem) {
                t.gridItem.checkOutItem.clean_is_finish = 1;
                t.gridItem.checkOutItem.clean_status = 3;
                t.gridItem.formAlert = 0;
            }
            else {
                t.gridItem.clean_is_finish = 1;
                t.gridItem.clean_status = 3;
            }

            t.boxName = 'report-status';

        },

        closeWin() {
      let t = this;
      t.boxName = 'normal';
    },
    
        reportReset() {
            let t = this;

            if (t.gridItem.checkOutItem) {
                t.gridItem.checkOutItem.clean_is_finish = 1;
                t.gridItem.checkOutItem.clean_status = 2;
            }
            else {
                t.gridItem.clean_is_finish = 1;
                t.gridItem.clean_status = 2;
            }

            t.boxName = 'report-status';
        },

        showReport() {
            let t = this;

            t.cleanTaskId = null;

            if (t.gridItem.checkOutItem.clean_status == 3) {
                t.cleanTaskId = t.gridItem.checkOutItem.task_id;
            }
            else if (t.gridItem.clean_status == 3) {
                t.cleanTaskId = t.gridItem.task_id;
            }

            if (/localhost/.test(location.host)) {
                t.cleanTaskId = 2956;
            }

            if (!t.cleanTaskId) {
                A.err('日報未提出');
                return;
            }

            t.boxName = 'report';
        },

        goFillForm() {
            this.boxName = 'fill-form';
        },

        afterFormSubmitted(form_id) {
            this.gridItem.checkInItem.form_id = form_id;
            this.boxName = 'normal';
        },

        tapGridItem(item) {
            let t = this;

            if (!item.checkInItem) {
                if (item.nextCheckInItem) {
                    item.checkInItem = item.nextCheckInItem;
                }
                else {
                    return;
                }
            }
            else {
                item.checkInItem = item.checkInItem;
            }

            // if (!item.checkOutItem) {
            //   item.checkOutItem = {};
            // }

            t.gridItem = item;

            if (item.checkInItem.emergency_status == 2) {
                t.boxName = 'emergency-order';
            }
            else if (!t.gridItem.cleaner_id && (!t.gridItem.checkOutItem || (t.gridItem.checkOutItem && !t.gridItem.checkOutItem.cleaner_id))) {
                t.boxName = 'set-cleaner';
                t.editCleaner();
            }
            else if (item.checkInItem.emergency_status == 3) {
                t.boxName = 'changed-people';
            }
            else if (item.checkInItem != item.nextCheckInItem && item.checkInItem.form_status == 1) {
                t.boxName = 'unfill';
            }
            else if (t.gridItem.clean_is_finish == 0) {
                t.boxName = 'report-status';
            }
            else {
                t.boxName = 'normal';
            }

            t.showWindow = true;
        },

        editOrder2(item) {
            let t = this;

            t.gridItem = item;

            t.orderForm.id = null;

            t.boxName = 'edit-order';

            t.editOrder();

            t.showWindow = true;
        },

        loadData() {

            let t = this;

            t.inited = false;

            t.roomGrid = {};
            t.checkInDict = {};
            t.checkOutDict = {};
            t.extraTaskDict = {};
            t.roomCheckInDict = {};
            t.ksDict = {};
            t.roomDict = {};

            axios.get('room').then(res => {

                if (res.data.status == 1) {

                    let arr = res.data.options.items;

                    arr.forEach(room => {
                        room.invisible = false;
                        room.selected = false;
                        room.active = false;
                        t.roomDict[room.id] = room;
                    });

                    t.list.room = arr;

                    axios.get('group').then(res => {
                        if (res.data.status == 1) {
                            let arr = res.data.options.items;
                            arr.forEach(group => {
                                group.editing = false;
                                group.selected = false;
                                group.expanded = true;
                                group.rooms = [];
                                let roomIds = group.room_ids.split(',');
                                roomIds.forEach(roomId => {
                                    if (t.roomDict[roomId]) {
                                        t.roomDict[roomId].selected = true;
                                        group.rooms.push(t.roomDict[roomId]);
                                    }
                                });
                            });

                            t.list.group = arr;

                            axios.get('order?_with=tasks&date=' + t.currentDate.format('yyyy/MM/dd')).then(res => {
                                if (res.data.status == 1) {

                                    let arr = res.data.options.items;

                                    arr.forEach(order => {
                                        let checkInDate = order.checkin_date.replace(/\d{4}[\/-]/, '').replace('-', '/');
                                        if (!t.checkInDict[checkInDate])
                                            t.checkInDict[checkInDate] = {};
                                        t.checkInDict[checkInDate][order.room_id] = order;

                                        if (!t.roomCheckInDict[order.room_id])
                                            t.roomCheckInDict[order.room_id] = {};
                                        t.roomCheckInDict[order.room_id][checkInDate] = order;

                                        if (!t.ksDict[checkInDate])
                                            t.ksDict[checkInDate] = { k: 0, s: 0, d: 0 };

                                        if (order.k) {
                                            t.ksDict[checkInDate].k += Number(order.k);
                                            t.ksTotal.k += Number(order.k);
                                        }

                                        if (order.s) {
                                            t.ksDict[checkInDate].s += Number(order.s);
                                            t.ksTotal.s += Number(order.s);
                                        }

                                        if (order.d) {
                                            t.ksDict[checkInDate].d += Number(order.d);
                                            t.ksTotal.d += Number(order.d);
                                        }

                                        let checkOutDate = order.checkout_date.replace(/\d{4}[\/-]/, '').replace('-', '/');

                                        if (!t.checkOutDict[checkOutDate])
                                            t.checkOutDict[checkOutDate] = {};
                                        t.checkOutDict[checkOutDate][order.room_id] = order;

                                        if (order.tasks) {
                                            order.tasks.forEach(task => {
                                                if (task.is_extra == 1) {
                                                    let cleanDate = task.date.replace(/\d{4}[\/-]/, '').replace('-', '/');
                                                    if (!t.extraTaskDict[cleanDate])
                                                        t.extraTaskDict[cleanDate] = {};
                                                    t.extraTaskDict[cleanDate][order.room_id] = task;
                                                }
                                            });
                                        }

                                    });

                                    let dateExtras = res.data.options.date_extras;

                                    if (dateExtras)
                                        dateExtras.forEach(item => {
                                            if (!t.dateExtraDict[item.room_id])
                                                t.dateExtraDict[item.room_id] = {};
                                            t.dateExtraDict[item.room_id][item.date] = item;
                                        });

                                    t.initRoomGrid();
                                }
                            });

                        }
                    });
                }
            });

        },

        onSelectCurrentDate(d) {
            let t = this;

            t.currentDate = d;

            t.refreshCurrentStats();

            $('.beautyscroll').scrollLeft(0);

            t.showDatePopover = false;

        },

        onSelectStartDate(d) {
            let t = this;

            t.currentDate = d;

            t.startDate = d;

            t.endDate = new Date(t.startDate.getFullYear(), t.startDate.getMonth(), t.startDate.getDate() + 31);

            t.days = 31;

            let todayText = t.today.format('MM/dd');

            t.monthGrid = {};

            for (let i = 1; i <= t.days; i++) {
                let d = new Date(t.startDate.format('yyyy/MM/dd'));

                d.setDate(d.getDate() + i - 1);

                let date = d.format('MM/dd');

                t.monthGrid[date] = {
                    k: 0,
                    s: 0,
                    suffix: ['日', '月', '火', '水', '木', '金', '土'][d.getDay()],
                    is_today: date == todayText
                };
            }

            t.loadData();

            // t.refreshCurrentStats();

            t.showDatePopover = false;

        },

        refreshDateItem(gridItem) {

            let t = this;

            gridItem.bg_color = 'bg-pink';

            let cleanDeadline = (new Date(gridItem.checkout_date + ' 13:00:00')).valueOf();

            let now = (new Date()).valueOf();

            if (gridItem.clean_status == 99) {
                //无清扫员
                gridItem.bg_color = 'bg-pink';
            }
            else if (gridItem.clean_status == 1) {
                gridItem.bg_color = 'bg-pink';
            }
            else if (gridItem.clean_status == 2) {
                //正在清扫
                gridItem.bg_color = 'bg-yellow';
            }
            else if (gridItem.clean_status == 3) {
                //清扫完成
                gridItem.bg_color = 'bg-green';
            }

            let d = new Date(t.today.getFullYear() + '/' + gridItem.date);
            let d2 = new Date(t.today.format('yyyy/MM/dd'));

            d2.setDate(d2.getDate() + 3);

            if (gridItem.clean_status == 99 && d2 > d && d >= new Date(t.today.format('yyyy/MM/dd'))) {
                gridItem.bg_color = 'bg-orange';
            }

            if (gridItem.checkin_date) {
                d = new Date(gridItem.checkin_date);
                d2 = new Date(t.today.getFullYear() + '/' + gridItem.date);

                d = d.format('yyyy/MM/dd');
                d2 = d2.format('yyyy/MM/dd');

                if (d == d2 && gridItem.override_clean_status == 3) {
                    gridItem.bg_color = 'bg-green';
                }
            }

            if (gridItem.clean_status != 2 && gridItem.clean_status != 3) {
                if (now > cleanDeadline) {
                    gridItem.clean_delayed = true;
                    gridItem.bg_color = 'bg-red';
                }
            }

        },

        refreshContinuous(gridItem, grid) {

            let t = this;

            let checkInItem = gridItem.checkInItem;

            if (checkInItem && checkInItem.continuous_days > 1) {

                gridItem.continuous_days = checkInItem.continuous_days;

                let room = t.roomDict[gridItem.room_id];

                let date = (new Date(checkInItem.checkin_date)).format('MM/dd');

                for (let i = 1; i < checkInItem.continuous_days; i++) {

                    let d = new Date(date);

                    d.setDate(d.getDate() + i);

                    let date2 = d.format('MM/dd');

                    if (!grid[date2])
                        grid[date2] = {};

                    let dateItem = grid[date2][room.id];

                    if (!dateItem)
                        dateItem = grid[date2][room.id] = {
                            room_name: room.name,
                            room_id: room.id,
                            date: date2,
                            id: null,
                            cleaner_name: '',
                            cleaner_id: 0,
                            source: '',
                            status: 99,
                            bg_color: 'bg-grey',
                            // checkin_date: '',
                            // checkout_date: '',
                            // count_audlt: 0,
                            // count_child: 0,
                            // count_baby: 0,
                            // k: 0,
                            // s: 0,
                            continuous_days: 0,
                            is_continuous: false,
                            is_last_continuous: false,
                            cid: null,
                            form_status: 1,
                            emergency_status: 0,
                            year: d.getFullYear()
                        };

                    dateItem.sourceItem = checkInItem;
                    dateItem.is_continuous = true;
                    dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
                    dateItem.bg_color = gridItem.bg_color + '2';
                    dateItem.sourceCheckInItem = gridItem.checkInItem;

                    if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
                        let task = t.extraTaskDict[date2][room.id];
                        if (task.cleaner_id) {
                            dateItem.task_id = task.id;
                            dateItem.cleaner_id = task.cleaner_id;
                            dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
                            dateItem.clean_status = task.status;
                        }
                        t.refreshDateItem(dateItem);
                    }
                }

            }
        },

        refreshCurrentStats() {

            let t = this;

            t.currentStats = {
                task: 0,
                continuous: 0,
                empty: 0,
                checkin: 0
            };

            let currentDateStr = t.currentDate.format('MM/dd');

            t.list.group.forEach(group => {

                group.rooms.forEach(room => {

                    for (const date in t.monthGrid) {

                        let gridItem = t.roomGrid[date][room.id];

                        if (gridItem) {
                            gridItem.isCurrentDate = false;
                            gridItem.isA = !!((gridItem.checkOutItem && !!gridItem.checkOutItem.cleaner_id) ||
                                (gridItem.checkInItem && gridItem.checkInItem.emergency_status == 2) ||
                                (gridItem.checkInItem && gridItem.checkInItem.emergency_status == 3) ||
                                gridItem.checkOutItem);
                            gridItem.isB = gridItem.is_continuous;
                            gridItem.isC = !gridItem.checkInItem && !gridItem.is_continuous;
                            gridItem.isD = !!(gridItem.checkInItem);

                            if (currentDateStr == date) {

                                gridItem.isCurrentDate = true;

                                if (gridItem.isA)
                                    t.currentStats.task++;

                                if (gridItem.isB)
                                    t.currentStats.continuous++;

                                if (gridItem.isC)
                                    t.currentStats.empty++;

                                if (gridItem.isD)
                                    t.currentStats.checkin++;
                            }
                        }
                    }

                });
            });
        },

        initRoomGrid() {

            let t = this;
            let grid = {};

            function fillGrid() {

                t.list.group.forEach(group => {

                    group.rooms.forEach(room => {

                        t.days = 31;

                        for (let j = -15; j <= t.days + 15; j++) {
                            let d = new Date(t.startDate.format('yyyy/MM/dd'));

                            d.setDate(d.getDate() + j - 1);

                            let date = d.format('MM/dd');

                            if (!grid[date])
                                grid[date] = {};

                            let gridItem = grid[date][room.id];

                            if (!gridItem)
                                gridItem = grid[date][room.id] = {
                                    room_name: room.name,
                                    room_id: room.id,
                                    date: date,
                                    id: null,
                                    cleaner_name: '',
                                    cleaner_id: 0,
                                    task_id: null,
                                    // source: '',
                                    status: 99,
                                    bg_color: 'bg-grey',
                                    // checkin_date: '',
                                    // checkout_date: '',
                                    // count_audlt: 0,
                                    // count_child: 0,
                                    // count_baby: 0,
                                    // k: 0,
                                    // s: 0,
                                    continuous_days: 0,
                                    is_continuous: false,
                                    is_last_continuous: false,
                                    cid: null,
                                    form_status: 1,
                                    emergency_status: 0,
                                    year: d.getFullYear()
                                };


                            if (t.checkInDict[date] && t.checkInDict[date][room.id]) {

                                let checkInItem = {};

                                checkInItem.date = date;

                                // checkInItem.bg_color = 'bg-pink';

                                mirror(t.checkInDict[date][room.id], checkInItem);

                                checkInItem.bell_color = 'fill-white';

                                if (checkInItem.form_status == 1)
                                    checkInItem.bell_color = 'fill-red';

                                if (new Date(t.today.getFullYear() + '/' + date).valueOf() < t.today.valueOf())
                                    checkInItem.bell_color = 'fill-outline';

                                t.refreshDateItem(checkInItem);

                                gridItem.checkInItem = checkInItem;
                            }

                            if (t.checkOutDict[date] && t.checkOutDict[date][room.id]) {

                                let checkOutItem = {};

                                checkOutItem.date = date;

                                mirror(t.checkOutDict[date][room.id], checkOutItem);

                                t.refreshDateItem(checkOutItem);

                                gridItem.checkOutItem = checkOutItem;
                            }

                            if (gridItem.checkInItem) {

                                gridItem.checkInItem.room_name = gridItem.room_name;

                                gridItem.checkInItem.room_id = gridItem.room_id;

                                gridItem.checkInItem.dateInGrid = date;

                            }

                            if (gridItem.checkInItem) {

                                let checkInItem = gridItem.checkInItem;

                                gridItem.bg_color = checkInItem.bg_color;

                                if (checkInItem.continuous_days > 1) {

                                    for (let i = 1; i < checkInItem.continuous_days; i++) {

                                        let d = new Date(date);

                                        d.setDate(d.getDate() + i);

                                        let date2 = d.format('MM/dd');

                                        if (!grid[date2])
                                            grid[date2] = {};

                                        let dateItem = grid[date2][room.id];

                                        if (!dateItem)
                                            dateItem = grid[date2][room.id] = {
                                                room_name: room.name,
                                                room_id: room.id,
                                                date: date2,
                                                id: null,
                                                cleaner_name: '',
                                                cleaner_id: 0,
                                                source: '',
                                                status: 99,
                                                bg_color: 'bg-grey',
                                                // checkin_date: '',
                                                // checkout_date: '',
                                                // count_audlt: 0,
                                                // count_child: 0,
                                                // count_baby: 0,
                                                // k: 0,
                                                // s: 0,
                                                continuous_days: 0,
                                                is_continuous: false,
                                                is_last_continuous: false,
                                                cid: null,
                                                form_status: 1,
                                                emergency_status: 0,
                                                year: d.getFullYear()
                                            };

                                        dateItem.sourceItem = checkInItem;
                                        dateItem.is_continuous = true;
                                        dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
                                        dateItem.bg_color = gridItem.bg_color + '2';
                                        dateItem.continuous_bg_color = gridItem.bg_color + '2';

                                        if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
                                            let task = t.extraTaskDict[date2][room.id];
                                            if (task.cleaner_id) {
                                                dateItem.cleaner_id = task.cleaner_id;
                                                dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
                                            }
                                            t.refreshDateItem(dateItem);
                                        }
                                    }

                                }

                                t.refreshContinuous(gridItem, grid);

                            }

                            if (gridItem.checkOutItem) {
                                let checkOutItem = gridItem.checkOutItem;
                                gridItem.bg_color = checkOutItem.bg_color;
                                t.refreshContinuous(gridItem, grid);
                            }
                        }


                    });

                });

                t.list.group.forEach(group => {

                    group.rooms.forEach(room => {

                        t.days = 31;

                        for (let j = -15; j <= t.days + 15; j++) {
                            let d = new Date(t.startDate.format('yyyy/MM/dd'));

                            d.setDate(d.getDate() + j - 1);

                            let date = d.format('MM/dd');

                            if (!grid[date])
                                grid[date] = {};

                            let gridItem = grid[date][room.id];

                            if (gridItem.checkOutItem && !gridItem.checkInItem) {

                                let minDateVal = 0;
                                let minDate = '';
                                let dateVal = (new Date(t.today.getFullYear() + '/' + date)).valueOf();

                                for (const date2 in t.roomCheckInDict[room.id]) {

                                    let date2Val = (new Date(t.today.getFullYear() + '/' + date2)).valueOf();

                                    if (date2Val > dateVal) {
                                        if (minDateVal == 0) {
                                            minDateVal = date2Val;
                                            minDate = date2;
                                        }
                                        else if (date2Val < minDateVal) {
                                            minDateVal = date2Val;
                                            minDate = date2;
                                        }
                                    }
                                }

                                if (minDate) {
                                    if (grid[minDate] && grid[minDate][room.id] && grid[minDate][room.id].checkInItem) {
                                        gridItem.nextCheckInItem = grid[minDate][room.id].checkInItem;
                                        gridItem.nextCheckInGridItem = grid[minDate][room.id];

                                        if (gridItem.nextCheckInItem) {
                                            gridItem.nextCheckInItem.cleaned_at = date;
                                            gridItem.nextCheckInItem.bg_color = gridItem.bg_color;
                                            gridItem.nextCheckInGridItem.bg_color = gridItem.bg_color;

                                            let checkInItem = gridItem.nextCheckInItem;
                                            if (checkInItem.continuous_days > 1) {

                                                for (let i = 1; i < checkInItem.continuous_days; i++) {

                                                    let d = new Date(checkInItem.date);

                                                    d.setDate(d.getDate() + i);

                                                    let date2 = d.format('MM/dd');

                                                    if (!grid[date2])
                                                        grid[date2] = {};

                                                    let dateItem = grid[date2][room.id];

                                                    dateItem.sourceItem = checkInItem;
                                                    dateItem.is_continuous = true;
                                                    dateItem.is_last_continuous = i == checkInItem.continuous_days - 1;
                                                    dateItem.bg_color = gridItem.bg_color + '2';
                                                    dateItem.continuous_bg_color = gridItem.bg_color + '2';

                                                    if (t.extraTaskDict[date2] && t.extraTaskDict[date2][room.id]) {
                                                        let task = t.extraTaskDict[date2][room.id];
                                                        if (task.cleaner_id) {
                                                            dateItem.cleaner_id = task.cleaner_id;
                                                            dateItem.cleaner_name = t.cleanerDict[task.cleaner_id].name;
                                                        }
                                                        t.refreshDateItem(dateItem);
                                                    }
                                                }

                                            }

                                            t.refreshContinuous(gridItem.nextCheckInGridItem, t.roomGrid);
                                        }

                                        let fullDate = (new Date(t.today.getFullYear() + '/' + gridItem.date)).format('yyyy-MM-dd');

                                        if (t.dateExtraDict[room.id] && t.dateExtraDict[room.id][fullDate]) {
                                            let dateExtra = t.dateExtraDict[room.id][fullDate];
                                            gridItem.dateExtra = dateExtra;
                                        }
                                    }
                                }
                            }
                        }
                    });
                });
            }

            fillGrid();

            t.roomGrid = grid;

            t.refreshInvisible();

            t.refreshCurrentStats();

            t.inited = true;

            // setTimeout(function () {
            //     $('.beautyscroll').scrollLeft((t.today.getDate() - 3) * 120);
            // }, 100);
        },

        refreshInvisible() {
            let t = this;
            let date = t.currentDate.format('MM/dd');
            let roomGrid = t.roomGrid;

            t.list.group.forEach(group => {

                group.rooms.forEach(room => {

                    if (t.toggle.all) {
                        room.invisible = false;
                    }
                    else {
                        room.invisible = true;

                        if ((roomGrid[date][room.id].isA && t.toggle.task) ||
                            (roomGrid[date][room.id].isB && t.toggle.continuous) ||
                            (roomGrid[date][room.id].isC && t.toggle.empty) ||
                            (roomGrid[date][room.id].isD && t.toggle.checkin))
                            room.invisible = false;
                    }
                });

            });
        },

        selectRoom(room) {
            let t = this;
            if (t.curRoom != room) {
                t.curRoom = room;
            }
            else {
                t.curRoom = null;
            }
        },

        editGroup(group) {
            let t = this;
            if (t.curGroup) {
                t.curGroup.selected = false;
            }
            group.editing = true;
            t.$forceUpdate();
        },

        saveGroup(group) {
            let t = this;

            if (t.busying)
                return;

            group.editing = false;

            t.busying = true;

            let f = { name: group.name };

            let ids = [];

            group.rooms.forEach(room => {
                ids.push(room.id);
            });

            f.room_ids = ids.join(',');

            axios.put('group/' + group.id, f).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    A.toast('Saved.');
                }
            });

        },

        removeGroup(group) {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            t.list.group.remove(group);

            axios.delete('group/' + group.id).then(res => {
                t.busying = false;
                if (res.data.status == 1) {

                }
            });

        },

        addGroup(idx) {
            let t = this;

            let f = {
                'name': '未命名'
            };
            if (t.busying)
                return;

            t.busying = true;

            axios.post('group', f).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    let group = res.data.options;
                    group.rooms = [];
                    group.editing = false;
                    group.selected = false;
                    group.expanded = true;
                    t.list.group.push(group);
                    t.refreshGroupIndex();
                    t.$nextTick(() => {
                        let ele = document.getElementById('groupItems');
                        ele.scrollTop = ele.scrollHeight;
                    });
                    t.$forceUpdate();
                }
            });
        },

        selectGroup(group) {
            let t = this;
            if (t.curGroup) {
                t.curGroup.selected = false;
            }
            if (t.curGroup != group) {
                t.curGroup = group;
                group.selected = true;
            }
            else {
                t.curGroup = null;
            }
        },

        moveUp() {
            let t = this;
            if (t.curGroup && t.curGroup.selected) {
                let idx = t.list.group.indexOf(t.curGroup);
                if (idx > 0) {
                    let o = t.list.group[idx - 1];
                    t.list.group[idx - 1] = t.curGroup;
                    t.list.group[idx] = o;
                    t.$forceUpdate();
                }
            }
        },

        moveDown() {
            let t = this;
            if (t.curGroup && t.curGroup.selected) {
                let idx = t.list.group.indexOf(t.curGroup);
                if (idx < t.list.group.length - 1) {
                    let o = t.list.group[idx + 1];
                    t.list.group[idx + 1] = t.curGroup;
                    t.list.group[idx] = o;
                    t.$forceUpdate();
                }
            }
        },

        moveUp2() {
            let t = this;
            if (t.curRoom) {
                let idx = t.curGroup.rooms.indexOf(t.curRoom);
                if (idx > 0) {
                    let o = t.curGroup.rooms[idx - 1];
                    t.curGroup.rooms[idx - 1] = t.curRoom;
                    t.curGroup.rooms[idx] = o;
                    t.$forceUpdate();
                }
            }
        },

        moveDown2() {
            let t = this;
            if (t.curRoom) {
                let idx = t.curGroup.rooms.indexOf(t.curRoom);
                if (idx < t.curGroup.rooms.length - 1) {
                    let o = t.curGroup.rooms[idx + 1];
                    t.curGroup.rooms[idx + 1] = t.curRoom;
                    t.curGroup.rooms[idx] = o;
                    t.$forceUpdate();
                }
            }
        },

        moveRight() {

            let t = this;

            if (t.curRoom) {
                t.curGroup.rooms.remove(t.curRoom);
                t.fakeId++;
            }

        },

        moveRight2() {
            let t = this;

            t.curGroup.rooms.clear();

            t.fakeId++;

        },

        moveLeft() {
            let t = this;

            let arr = t.filteredRooms;

            arr.forEach(room => {
                if (room.active) {
                    room.selected = true;
                    t.curGroup.rooms.push(room);
                }
            });

            t.initRoomGrid();

            t.fakeId++;
        },

        moveLeft2() {
            let t = this;

            let arr = t.filteredRooms;

            arr.forEach(room => {
                room.selected = true;
                t.curGroup.rooms.push(room);
            });

            t.initRoomGrid();

            t.fakeId++;

        },

        editOrder() {
            let t = this;

            if (t.gridItem.checkInItem && t.gridItem.checkInItem != t.gridItem.nextCheckInItem) {
                t.orderForm = {};
                mirror(t.gridItem.checkInItem, t.orderForm);
            }
            else {
                mirror(t.orderForm_o, t.orderForm);
                t.orderForm.checkin_date = t.gridItem.year + '/' + t.gridItem.date;
                t.orderForm.source = 'MM';
                t.orderForm.room_id = t.gridItem.room_id;
                t.calcKS();
            }
        },


        editCleaner() {

            let t = this;

            let gridItem = t.gridItem;

            if (gridItem.checkOutItem) {
                t.selectedStatus = t.statusDict[gridItem.checkOutItem.clean_status];
                t.selectedCleaner = t.cleanerDict[gridItem.checkOutItem.cleaner_id];
            }
            else if (gridItem.is_continuous && gridItem.task_id) {
                t.selectedStatus = t.statusDict[gridItem.clean_status];
                t.selectedCleaner = t.cleanerDict[gridItem.cleaner_id];
            }
        },

        saveCleaner() {
            let t = this;

            let gridItem = t.gridItem;

            let cid;

            if (t.selectedCleaner == -1)
                cid = null;
            else if (t.selectedCleaner)
                cid = t.selectedCleaner.id;

            if (t.busying)
                return;

            t.busying = true;

            let f = { cleaner_id: cid };

            if (gridItem.is_continuous) {
                f.date = (new Date(t.today.getFullYear() + '/' + gridItem.date)).format('yyyy/MM/dd');
                f.room_id = gridItem.room_id;
                f.order_id = gridItem.sourceCheckInItem.id;
                f.status = 1;
                f.clean_status = 1;
            }
            else {
                f.id = t.gridItem.checkOutItem.id;
                f.clean_status = 1;
                if (t.selectedStatus)
                    f.clean_status = t.selectedStatus.id;
            }

            axios.post('order/setCleaner', f).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    A.toast('Saved.');

                    t.showWindow = false;

                    if (cid) {
                        if (gridItem.is_continuous) {

                            gridItem.checkOutItem.cleaner_id = cid;
                            gridItem.checkOutItem.clean_status = f.clean_status;
                            gridItem.checkOutItem.cleaner_name = t.cleanerDict[gridItem.checkOutItem.cleaner_id].name;

                            t.refreshDateItem(gridItem, true);
                        }
                        else {
                            gridItem.checkOutItem.cleaner_id = cid;
                            gridItem.checkOutItem.clean_status = f.clean_status;
                            gridItem.checkOutItem.cleaner_name = t.cleanerDict[gridItem.checkOutItem.cleaner_id].name;

                            t.refreshDateItem(gridItem.checkOutItem, true);
                            gridItem.bg_color = gridItem.checkOutItem.bg_color;

                            if (gridItem.nextCheckInItem) {
                                gridItem.nextCheckInItem.bg_color = gridItem.bg_color;
                                gridItem.nextCheckInGridItem.bg_color = gridItem.bg_color;
                                t.refreshContinuous(gridItem.nextCheckInGridItem, t.roomGrid);
                            }
                        }


                    }
                    else {
                        if (gridItem.is_continuous) {

                            gridItem.checkOutItem.cleaner_id = null;
                            gridItem.checkOutItem.clean_status = 99;
                            gridItem.checkOutItem.cleaner_name = null;

                            gridItem.checkOutItem.bg_color = gridItem.checkOutItem.continuous_bg_color;
                        }
                        else {
                            gridItem.checkOutItem.cleaner_id = null;
                            gridItem.checkOutItem.clean_status = 99;
                            gridItem.checkOutItem.cleaner_name = null;

                            t.refreshDateItem(gridItem.checkOutItem, true);
                            gridItem.bg_color = gridItem.checkOutItem.bg_color;
                        }
                    }

                    t.refreshContinuous(gridItem, t.roomGrid);

                    t.showCleanerEditor = false;
                }
            });
        },


        openBox(gridItem, type) {

            let t = this;

            if (type == 'report-status') {
                if (!gridItem.task_id && !gridItem.checkOutItem) {
                    return;
                }
            }

            t.gridItem = gridItem;

            if (!gridItem.checkInItem) {
                if (gridItem.nextCheckInItem) {
                    gridItem.checkInItem = gridItem.nextCheckInItem;
                }
                else {
                    if (type != 'order' && type != 'cleaner' && type != 'report-status')
                        return;
                }
            }
            else {
                gridItem.checkInItem = gridItem.checkInItem;
            }

            if (t.gridItem.checkInItem && t.gridItem.checkInItem.emergency_status == 2) {
                t.boxName = 'emergency-order';
                t.showWindow = true;
                if (type != 'emergency-order') {
                    A.err('急予約の処理を完了してください。');
                }
                return;
            }

            if (type == 'status') {

                console.log(t.gridItem);

                if (t.gridItem.checkInItem != t.gridItem.nextCheckInItem && t.gridItem.checkInItem.form_status == 1) {
                    t.boxName = 'unfill';
                }
                else if (t.gridItem.checkInItem.form_id) {
                    t.boxName = 'view-form';
                }

            }

            else if (type == 'people') {
                if (t.gridItem.checkInItem.emergency_status == 3) {
                    t.boxName = 'changed-people';
                }
                else {
                    t.boxName = 'normal-people';
                }
            }

            else if (type == 'order') {
                t.boxName = 'edit-order';
                t.editOrder();
            }

            else if (type == 'cleaner') {
                t.boxName = 'set-cleaner';
                t.editCleaner();
            }

            else if (type == 'report-status') {
                t.boxName = 'report-status';
            }

            else if (type == 'profile') {
                t.boxName = 'normal';
            }

            t.showWindow = true;
        },

        saveOrder() {
            let t = this;

            let f = t.orderForm;

            if (!f.checkin_date) {
                A.err('Please enter check-in date')
                return;
            }

            if (!f.checkout_date) {
                A.err('Please enter check-out date')
                return;
            }

            if (f.checkout_date.length == 8) {
                f.checkout_date = f.checkout_date.substring(0, 4) + '-' + f.checkout_date.substring(4, 6) + '-' + f.checkout_date.substring(6, 8);
            }
            else if (f.checkout_date.length < 8) {
                A.err('Invalid check-out date format');
                return;
            }

            let leftDays = t.calcDateDiffDays(f.checkin_date, f.checkout_date);

            if (leftDays < 1) {
                A.err('Please check the check-out date');
                return;
            }

            f.continuous_days = leftDays;

            if (t.busying)
                return;

            t.busying = true;

            f.room_id = t.gridItem.room_id;

            let fields = ['room_id', 'checkin_date', 'checkout_date', 'count_audlt', 'count_child', 'count_baby', 'remark', 'source', 'continuous_days', 'k', 's', 'd'];

            let data = getFields(f, fields);

            if (f.id) {
                axios.put('order/' + f.id, data).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        A.toast('Saved.');
                        t.showWindow = false;
                        t.loadData();
                    }
                });
            }
            else {
                axios.post('order', data).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        A.toast('Saved.');
                        t.showWindow = false;
                        t.loadData();
                    }
                });
            }

        },

        resolveEmergency2() {
            let t = this;

            let gridItem = t.gridItem;

            if (t.busying)
                return;

            t.busying = true;

            axios.put('order/' + gridItem.checkInItem.id, { emergency_status: 1 }).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    gridItem.emergency_status = 1;
                    gridItem.checkInItem.emergency_status = 1;
                    A.toast('Saved.');
                    t.showWindow = false;
                    t.resolve();
                }
            });
        },

        resolveEmergency3() {
            let t = this;

            let gridItem = t.gridItem;

            if (t.busying)
                return;

            t.busying = true;

            if (gridItem.checkInItem.id) {
                axios.put('order/' + gridItem.checkInItem.id, { emergency_status: 1 }).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {
                        gridItem.checkInItem.emergency_status = 1;
                        A.toast('Saved.');
                        t.showWindow = false;
                        t.resolve();
                    }
                });
            }
        },

        resolve() {
            let t = this;
            t.tapGridItem(t.gridItem);
        },

        goContact() {
            A.err('この機能は現在ご利用いただけません。');
        },

        viewForm() {
            this.boxName = 'view-form';
        },

        goContact() {
            this.showUnfillForm = false;
        },

        calcKS() {
            let t = this;
            let f = t.orderForm;

            let room = t.roomDict[f.room_id];
            if (!room) return;
            let type = room.type;

            let k = 0, s = 0, d = 0;
            let countTotal = Number(f.count_audlt) + Number(f.count_child);

            const kByType = { A: 1, B: 2, C: 1, D: 0, E1: 0, E2: 0, F1: 1, F2: 1 };
            const dByType = { A: 0, B: 0, C: 0, D: 0, E1: 2, E2: 3, F1: 2, F2: 3 };
            const sTable = {
                A:  [0, 1, 2, 2, 3, 4, 5, 6, 7, 8, 9],
                B:  [0, 1, 2, 1, 2, 3, 4, 5, 6, 7, 8],
                C:  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                D:  [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                E1: [0, 1, 2, 1, 2, 3, 4, 5, 6, 7, 8],
                E2: [0, 1, 1, 1, 1, 3, 4, 5, 6, 7, 8],
                F1: [0, 1, 1, 2, 2, 2, 3, 4, 5, 6, 7],
                F2: [0, 1, 1, 1, 1, 3, 3, 4, 5, 6, 7],
            };
            const sOver10Sub = { A: 1, B: 2, C: null, D: 0, E1: 2, E2: 2, F1: 3, F2: 3 };

            if (kByType[type] !== undefined) {
                k = kByType[type];
                d = dByType[type];
                let p = countTotal;
                if (p <= 10) {
                    s = sTable[type][Math.max(0, p)];
                } else if (type == 'C') {
                    s = 0;
                } else {
                    s = p - sOver10Sub[type];
                }
            } else {
                k = Math.ceil(f.count_audlt / 2.0);
            }

            t.orderForm.k = k;
            t.orderForm.s = s;
            t.orderForm.d = d;

            t.$forceUpdate();
        },

        refreshToggles(key) {

            let t = this;

            switch (key) {
                case 'task':
                    if (t.toggle.task)
                        t.toggle.continuous = t.toggle.checkin = t.toggle.empty = t.toggle.all = false;
                    else
                        t.toggle.continuous = t.toggle.checkin = t.toggle.empty = true;
                    break;

                case 'continuous':
                    if (t.toggle.continuous)
                        t.toggle.task = t.toggle.checkin = t.toggle.empty = t.toggle.all = false;
                    else
                        t.toggle.task = t.toggle.checkin = t.toggle.empty = true;
                    break;
                case 'checkin':

                    if (t.toggle.checkin)
                        t.toggle.task = t.toggle.continuous = t.toggle.empty = t.toggle.all = false;
                    else
                        t.toggle.task = t.toggle.continuous = t.toggle.empty = true;
                    break;
                case 'empty':

                    if (t.toggle.empty)
                        t.toggle.task = t.toggle.continuous = t.toggle.checkin = t.toggle.all = false;
                    else
                        t.toggle.task = t.toggle.continuous = t.toggle.checkin = true;
                    break;
                case 'all':

                    if (t.toggle.all) {
                        t.toggle.task = t.toggle.continuous = t.toggle.checkin = t.toggle.empty = false;
                    }
                    else {
                        t.toggle.continuous = t.toggle.checkin = t.toggle.empty = false;
                        t.toggle.task = true;
                    }
                    break;

            }

            if (key != 'all') {
                if (!t.toggle.task && !t.toggle.continuous && !t.toggle.checkin && !t.toggle.empty)
                    t.toggle.all = true;
            }

            t.refreshInvisible();
        },

        viewCleanReport(gridItem) {

            let t = this;
            let width = 790;
            let height = 820;
            let leftPosition = (window.screen.width - width) / 2;
            let topPosition = (window.screen.height - height) / 2;
            let windowFeatures = 'width=' + width + ',height=' + height + ',left=' + leftPosition + ',top=' + topPosition + ',resizable=yes,scrollbars=yes';

            let taskId;

            if (gridItem.checkOutItem)
                taskId = gridItem.checkOutItem.task_id;
            else if (gridItem.is_continuous)
                taskId = gridItem.task_id;

            let popup = window.open(location.origin + '/#/report?task_id=' + taskId, '_blank', windowFeatures);

            function handleMsg(event) {
                if (event.source === popup && typeof event.data === 'string') {
                    window.removeEventListener('message', handleMsg);

                    if (gridItem.checkOutItem) {
                        gridItem.checkOutItem.clean_status = 2;

                        t.refreshDateItem(gridItem.checkOutItem, true);

                        gridItem.bg_color = gridItem.checkOutItem.bg_color;

                        t.refreshContinuous(gridItem, t.roomGrid);
                    }
                    else {
                        gridItem.clean_status = 2;
                        gridItem.bg_color = 'bg-yellow';
                    }

                    if (gridItem.nextCheckInItem) {
                        gridItem.nextCheckInItem.bg_color = gridItem.bg_color;
                        gridItem.nextCheckInGridItem.bg_color = gridItem.bg_color;
                        t.refreshContinuous(gridItem.nextCheckInGridItem, t.roomGrid);
                    }

                    t.$forceUpdate();
                }
            }

            window.addEventListener('message', handleMsg);

            return;
        },

        scrollToDate(date) {
            this.$refs.calendar.scrollToDate(date);
        },

        saveTableScale() {
            localStorage['cleaner_table_scale'] = this.tableScale;
        },
    },
    data() {
        return {
            tableScale: 1,
            mode: 'v2',
            // mode:'schedule',
            minDate: new Date('2024/01/01'),
            currentDate: Date.today(),
            today: Date.today(),
            days: 31,
            editingGroup: null,
            gridItem: null,
            selectedCleaner: null,
            selectedStatus: null,
            showCleanerEditor: false,
            showCleanerPopover: false,
            showStatusPopover: false,
            showGroupsEditor: false,
            showDatePopover: false,
            showWindow: false,
            //boxName: 'edit-order',
            //boxName: 'view-form',
            boxName: 'fill-form',
            groupForm: {},
            groupForm_o: {
                name: '',
                rooms_ids: null
            },
            orderForm: {},
            orderForm_o: {
                id: null,
                room_id: null,
                checkin_date: '',
                checkout_date: '',
                count_audlt: 1,
                count_child: 0,
                count_baby: 0,
                k: 1,
                s: 0,
                d: 0,
                _overwrite: false,
                max_k: 99,
                max_s: 99,
                max_d: 99
            },

            month: 2,
            list: {
                status: [
                    { id: 1, text: '未開始' },
                    { id: 2, text: '清掃中' },
                    { id: 3, text: '完　了' },
                ],
                room: [],
                group: [],
                cleaner: [],
                selectedRoom: [],
                selectableRoom: [],
                selectedGroup: [],
            },
            dict: {
                group: {},
                waitingTask: {},
            },
            search: {
                tag: [], room_name: ''
            },
            curGroup: null,
            curRoom: null,
            toggle: {
                all: true,
                task: false,
                continuous: false,
                empty: false,
                checkin: false
            },
            inited: false,
            monthGrid: {},
            roomGrid: {},
            checkInDict: {},
            checkOutDict: {},
            extraTaskDict: {},
            roomCheckInDict: {},
            statusDict: {},
            ksDict: {},
      ksTotal: { k: 0, s: 0, d: 0 },
            roomDict: {},
            cleanerDict: {},
            dateExtraDict: {},
            currentStats: {
                task: 0,
                continuous: 0,
                empty: 0,
                checkin: 0
            },
            emptyRoomMode: false,
        };
    },
    computed: {
        filteredRooms() {
            let t = this;
            let arr = [];

            let ids = [];

            t.fakeId;

            t.list.group.forEach((group) => {
                if (group.rooms) {
                    group.rooms.forEach((room) => {
                        ids.push(room.id);
                    });
                }
            });

            t.list.room.forEach((room) => {
                if (ids.indexOf(room.id) < 0) {
                    if (t.search.room_name && room.name.indexOf(t.search.room_name) < 0)
                        return;
                    arr.push(room);
                }
            });

            return arr;
        },

        filteredTags() {
            let t = this;

            let arr = [];

            t.list.tag.forEach(item => {
                if (t.keywordSearch.tag_name && (item.name.indexOf(t.keywordSearch.tag_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedTags() {
            let t = this;

            let arr = [];

            t.list.tag.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },
    },
    watch: {
        mode: function () {
            localStorage['cleaner_table_mode'] = this.mode;
        }
    }
};
